import { ReactNodeViewRenderer } from "@tiptap/react";
import { BaseCodeBlock } from "@workith/editor-schema";
import { CodeBlockNodeView } from "./CodeBlockNodeView";

const CODE_BLOCK_EXIT_FENCE = "```";

const getCurrentLineRange = (text: string, cursorOffset: number) => {
  const lineStartOffset = text.lastIndexOf("\n", cursorOffset - 1) + 1;
  const nextLineBreakOffset = text.indexOf("\n", cursorOffset);
  const lineEndOffset = nextLineBreakOffset === -1 ? text.length : nextLineBreakOffset;

  return {
    line: text.slice(lineStartOffset, lineEndOffset),
    lineStartOffset,
    lineEndOffset,
  };
};

export const EnhancedCodeBlock = BaseCodeBlock.extend({
  addKeyboardShortcuts() {
    return {
      // Keep existing CodeBlockLowlight shortcuts
      ...this.parent?.(),

      // Override Enter to exit if the line just contains ```
      Enter: () => {
        const { state } = this.editor;
        const { selection } = state;
        const { $from, empty } = selection;

        if (!empty || $from.parent.type !== this.type) {
          return false;
        }

        const text = $from.parent.textContent;
        const { line, lineStartOffset, lineEndOffset } = getCurrentLineRange(
          text,
          $from.parentOffset
        );
        const trailingText = text.slice(lineEndOffset);

        if (line.trim() === CODE_BLOCK_EXIT_FENCE && trailingText.trim() === "") {
          return this.editor
            .chain()
            .deleteRange({
              from: $from.start($from.depth) + lineStartOffset,
              to: $from.start($from.depth) + text.length,
            })
            .exitCode()
            .run();
        }

        return false;
      },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(CodeBlockNodeView);
  },
});
